import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ScrollContext } from "react-router-scroll-4";
import "./index.scss";
import Dashboard from "./components/layouts/dashboard/main";
import Products from "./components/layouts/products/products";
import SingleProduct from "./components/layouts/singleproduct/singleproduct";
import Orders from "./components/layouts/order/order";
import Layout from "./components/app";
import PrivateRoute from "./components/PrivateRoute";
import Cart from "./components/cart";
import checkOut from "./components/checkout";
import OrderSummary from "./components/layouts/ordersummary/order-summary";
import ContactUs from "./components/layouts/contactus/contact";
import EditOrder from "./components/layouts/editorder/edit-order";
import MyProfile from "./components/layouts/myprofile/myprofile";
import OrderDetails from "./components/layouts/orderdetails/order-details";
import TermsConditions from "./components/layouts/privacypolicy/privacypolicy";
import Settings from "./components/layouts/settings/settings";
import AboutUs from "./components/layouts/aboutus/aboutus";
import Faq from "./components/pages/faq";
import PageNotFound from "./components/pages/404";
import Register from "./components/layouts/singup/register";
import Login from "./components/layouts/login/login";
import { connect } from "react-redux";
import { getMasterDetailsIdUrl, getTenantInfoUrl } from "./services";
import MainLoader from "./animation/MainLoader";
import { debuglogger } from "./utils/logger";
import SadadPaymentSample from "./components/layouts/sadadpaymentsample/SadadPaymentSample";
import SadadPaymentResponse from "./components/layouts/sadadpaymentsample/SadadPaymentResponse";
import OrderSadadPaymentResponse from "./components/layouts/sadadpaymentsample/OrderSadadPaymentResponse";
// import RequestProduct from "./components/layouts/requestproduct/RequestProduct";
import DashboardWrapper from "./app/dashboard/DashboardWrapper";
import { clearLocalStorageReload } from "./utils/utils";
import { getCall } from "./api/post";
import { setLanguageObjectToLocalStorage } from "./store";
import CollectionProducts from "./components/layouts/collection/CollectionProducts";
import Wishlist from "./components/wishlist/wishlist";
import wishListPrintView from "./components/wishlist/wishListPrintView";
import SharedWishList from "./components/shared-wishlist/SharedWishList";
import ShareWishListPrintView from "./components/shared-wishlist/ShareWishListPrintView";
import RewardPoints from "./components/layouts/rewardpoints/RewardPoints";
import Compare from "./components/compare/compare";
import AddressBook from "./components/layouts/address/AddressBook";
import Sitemap from "./components/layouts/sitemap/Sitemap";
import Downloads from "./components/downloads/downloads";

// below array is used to avoid same routes twice in url like /login/login
const routerArray = [
  "login",
  "signup",
  "products",
  "c",
  "s",
  "orders",
  "singleproduct",
  "cart",
  "checkout",
  "orderdetails",
  "ordersummary",
  "contactus",
  "editorder",
  "myprofile",
  "aboutus",
  "termsandconditions",
  "faq",
  "settings",
  "p",
  "o",
  "collection",
  "wishlist",
  "shared-wishlist",
  "compare",
  "rewardpoints",
];

class Routes extends Component {
  state = {
    colorCode: false,
    isLoading: true,
    masterDetailsObj: {},
    isShowXEModule: false,
  };

  componentDidMount() {
    document.querySelector(".loader-wrapper-splash").style = "display: none";
    this.initMasterDetailsId().then(() => {
      // Removed initLanguage() - using en.json directly
      // this.initColorCode();
      this.initTenantInfo();
      this.initThemeCode().then(() => {
        this.setState({ isLoading: false });
      });
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  // Removed initLanguage function - no longer needed

  initThemeCode = async () => {
    const { masterDetailsObj } = this.state;
    if (!masterDetailsObj.id) {
      return;
    }
    const themeCodeUrl = `settings/getThemeColor?filter[where][masterdetailId]=${masterDetailsObj.id}`;
    const themeCode = await getCall(themeCodeUrl, []);
    if (themeCode.error) {
      clearLocalStorageReload({ response: themeCode });
    } else {
      if (themeCode && themeCode.selected) {
        document
          .getElementById("color")
          .setAttribute(
            "href",
            `${process.env.PUBLIC_URL}/assets/css/color${themeCode.id}.css`
          );
      }
    }
  };

  renderBasename = () => {
    const { masterDetailsObj } = this.props;
    const publicUrl =
      masterDetailsObj && masterDetailsObj.isFromDomain
        ? ""
        : window.location.pathname.split("/")[1];
    const found = routerArray.find((element) => element === publicUrl);
    return found ? "" : publicUrl;
  };

  initTenantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const { id } = masterDetailsObj || {};
    if (!id) {
      return;
    }
    const tenantInfoUrl = getTenantInfoUrl(id);
    const tenantInfo = await getCall(tenantInfoUrl, []);
    if (tenantInfo.error) {
      clearLocalStorageReload({ response: tenantInfo });
      this.loadErrorMessageAnimation(tenantInfo.error.message);
    } else {
      if (tenantInfo && tenantInfo.length > 0) {
        const tenantItem = tenantInfo[0];
        const { text } = tenantItem || {};
        const tenantSettings = JSON.parse(text);
        if ("isShowXEModule" in tenantSettings) {
          this.setState({
            isShowXEModule: tenantSettings.isShowXEModule,
          });
        } else {
          this.setState({
            isShowXEModule: false,
          });
        }
      }
    }
  };

  render() {
    const { isShowXEModule } = this.state;
    const { masterDetailsObj, isLoading } = this.props;
    const { id } = masterDetailsObj || {};
    return (
      <>
        {id && (
          <BrowserRouter basename={this.renderBasename()}>
            <ScrollContext>
              <Switch>
                {isShowXEModule ? (
                  <PrivateRoute exact path={`/`} component={DashboardWrapper} />
                ) : (
                  <PrivateRoute
                    exact
                    path={`/`}
                    render={(routeProps) => (
                      <Dashboard
                        masterDetailsObj={masterDetailsObj}
                        {...routeProps}
                      />
                    )}
                  />
                )}
                <Route
                  path={`/wishlistprintview`}
                  component={wishListPrintView}
                />
                <Route
                  path={`/shared-wishlist-print/:id`}
                  component={ShareWishListPrintView}
                />
                <Layout>
                  <Switch>
                    {isShowXEModule ? (
                      <>
                        <Route exact path={`/login`} component={Login} />
                        <Route path="/dashboard" component={DashboardWrapper} />
                        <Route component={PageNotFound} />
                      </>
                    ) : (
                      <>
                        <Route exact path={`/login`} component={Login} />
                        <Route exact path={`/signup`} component={Register} />
                        <Route path={`/signup/isFromCheckout=:isFromCheckout`} component={Register} />
                        <Route path={`/signup/isFromDashboard=:isFromDashboard`} component={Register} />
                        <PrivateRoute path={`/products`} component={Products} />
                        <PrivateRoute path={`/c/:id`} component={Products} />
                        <PrivateRoute path={`/s/:id`} component={Products} />
                        {/* <Route path={`/products/:id`} component={Products} /> */}
                        <PrivateRoute path={`/orders`} component={Orders} />
                        <PrivateRoute path={`/singleproduct/:id`} component={SingleProduct} />
                        <PrivateRoute path={`/wishlist`} component={Wishlist} />
                        <PrivateRoute path={`/cart`} component={Cart} />
                        <PrivateRoute path={`/checkout`} component={checkOut} />
                        <PrivateRoute path={`/orderdetails/:id`} component={OrderDetails} />
                        <PrivateRoute path={`/ordersummary/:id`} component={OrderSummary} />
                        <Route path={`/contactus`} component={ContactUs} />
                        <PrivateRoute path={`/editorder/:id`} component={EditOrder} />
                        <PrivateRoute path={`/myprofile`} component={MyProfile} />
                        <Route path={`/aboutus`} component={AboutUs} />
                        <Route path={`/termsandconditions`} component={TermsConditions} />
                        <Route path={`/faq`} component={Faq} />
                        <Route path={`/settings`} component={Settings} />
                        <PrivateRoute path={`/p/:id`} component={SingleProduct} />
                        <PrivateRoute path={`/p`} component={Products} />
                        <PrivateRoute path={`/o`} component={Orders} />
                        <PrivateRoute path={`/collection`} component={CollectionProducts} />
                        <PrivateRoute path={`/compare`} component={Compare} />
                        <PrivateRoute path={`/rewardpoints`} component={RewardPoints} />
                        <PrivateRoute path={`/addressbook`} component={AddressBook} />
                        <PrivateRoute path={`/address`} component={AddressBook} />
                        <Route path={`/sitemap`} component={Sitemap} />
                        <PrivateRoute path={`/downloads`} component={Downloads} />
                        {/* <Route component={PageNotFound} /> */}
                      </>
                    )}
                  </Switch>
                </Layout>
              </Switch>
            </ScrollContext>
          </BrowserRouter>
        )}
      </>
    );
  }
}

export default Routes;
